/**
 * Категорийные плитки на главной — хардкод.
 * categoryId связывает плитку с фильтром API при переходе в витрину.
 * Изображения: WebP в public/categories/.
 */
export const CATEGORY_TILES = [
  {
    id: '1',
    name: 'Топперы',
    categoryId: '97',
    image: '/categories/topper.webp',
  },
  {
    id: '2',
    name: 'Подложки для тортов',
    categoryId: '26',
    image: '/categories/board.webp',
  },
  {
    id: '3',
    name: 'Молочная продукция',
    categoryId: '75',
    image: '/categories/dairy.webp',
  },
  {
    id: '4',
    name: 'Кондитерские посыпки',
    categoryId: '3',
    image: '/categories/sprinkles.webp',
  },
  {
    id: '5',
    name: 'Коробки для тортов',
    categoryId: '18',
    image: '/categories/cake-box.webp',
  },
  {
    id: '6',
    name: 'Шоколад, глазурь, какао',
    categoryId: '35',
    image: '/categories/chocolate.webp',
  },
  {
    id: '7',
    name: 'Пищевые красители',
    categoryId: '77',
    image: '/categories/food-coloring.webp',
  },
  {
    id: '8',
    name: 'Коробки для капкейков',
    categoryId: '20',
    image: '/categories/cupcake-box.webp',
  },
  {
    id: '9',
    name: 'Для леденцов и шоколада',
    categoryId: '12',
    image: '/categories/candy-mold.webp',
  },
  {
    id: '10',
    name: 'Фруктовое пюре и замороженные фрукты',
    categoryId: '68',
    image: '/categories/fruit-puree.webp',
  },
  {
    id: '11',
    name: 'Ореховая паста и мука',
    categoryId: '58',
    image: '/categories/nut-paste.webp',
  },
  {
    id: '12',
    name: 'Меренга и сахарные фигурки',
    categoryId: '45',
    image: '/categories/meringue.webp',
  },
];
